<template>
  <div class="approval">
    <!-- 发起审批(新增、编辑) | 盖章审批(新增、编辑) -->
    <!-- apply approval (create, update) and sign approval (create, update) -->
    <div class="content">
      <el-form
        size="mini"
        ref="formApproval"
        @submit.native.prevent
        :model="approvalModel"
        label-width="100px"
      >
        <el-form-item
          label="审批名称"
          prop="approvalName"
          :rules="rules.approvalName"
        >
          <el-input
            style="width: 300px"
            v-model="approvalModel.approvalName"
            placeholder="请输入审批名称"
          ></el-input>
        </el-form-item>

        <!-- approval range only apply approval -->

        <el-form-item label="审批类型">
          <el-radio v-model="approvalModel.approvalType" :label="1"
            >顺序审批（按先后顺序审批）</el-radio
          >
          <el-radio v-model="approvalModel.approvalType" :label="0"
            >会审 （无顺序，全员通过则通过）</el-radio
          >
        </el-form-item>
        <el-form-item v-if="flowType">
          <span slot="label">
            <span> 审批复用 </span>
            <el-tooltip effect="light" content="" placement="top">
              <div slot="content">
                开启后，如果当前审批流程中的审批人已参与了文件发起审批，则不需要再进行用印审批。
              </div>
              <i
                class="el-icon-question"
                style="font-size: 16px; color: #a1a1a1; cursor: pointer"
              ></i>
            </el-tooltip>
          </span>
          <el-radio v-model="approvalModel.useFileAuditFlag" :label="1"
            >开</el-radio
          >
          <el-radio v-model="approvalModel.useFileAuditFlag" :label="0"
            >关</el-radio
          >
        </el-form-item>
        <el-form-item
          label="审批流程"
          prop="approvalFlow"
          :rules="rules.approvalFlow"
        >
          <div style="display: inline; position: relative">
            <flow
              v-for="(v, index) in flows"
              @handleClickFlowRemove="handleClickFlowRemove"
              :model="v"
              :hiddenArrow="hiddenArrow"
              :key="index"
            >
              <div slot="username">
                <span style="color: #aaaaaa">{{ v.partyName }}</span>
              </div>
              <div slot="update">
                <a
                  class="custom-a"
                  @click="handleClickFlowUpdate(v)"
                  href="javascript:void(0);"
                  >修改</a
                >
              </div>
            </flow>
            <plus @handleClickFlowPlus="handleClickFlowPlus"></plus>
          </div>
        </el-form-item>
        <el-form-item
          label="抄送人"
          v-if="!flowType"
          prop="copyToName"
          :rules="rules.copyToName"
        >
          <div style="display: inline; position: relative">
            <flow
              v-for="(v, index) in copyToMembers"
              @handleClickFlowRemove="handleClickCopyRemove"
              :model="v"
              :hiddenArrow="false"
              :key="index"
            >
              <div slot="username">
                <span style="color: #aaaaaa">{{ v.partyName }}</span>
              </div>
              <div slot="update">
                <a
                  class="custom-a"
                  @click="handleClickCopyUpdate(v)"
                  href="javascript:void(0);"
                  >修改</a
                >
              </div>
            </flow>
            <plus @handleClickFlowPlus="handleClickCopyPlus"></plus>
          </div>
        </el-form-item>
        <!-- <el-form-item
          v-if="!flowType"
          label="使用范围"
          prop="selectUsers"
          :rules="rules.selectUsers"
        >
          <ul class="custom-inline">
            <li>
              <el-button @click="initMemberForm">选择</el-button>
            </li>
            <li>
              <el-tag
                @close="removeTag(tag)"
                v-for="tag in selectedApprovalRangeTags"
                :key="tag.corpGroupId"
                type="danger"
                closable
              >
                {{ tag.groupName }}
              </el-tag>
            </li>
          </ul>
        </el-form-item> -->
      </el-form>
    </div>
    <!-- footer (cancel and submit button) -->
    <div class="footer" style="text-align: right">
      <el-button @click="approvalCancel" size="mini">取消</el-button>
      <el-button
        @click="approvalOk"
        size="mini"
        type="danger"
        style="margin-right: 50px"
        >确定</el-button
      >
    </div>

    <!-- aprroval flow, select approvalor -->
    <el-dialog
      :title="addOrUpdateApprovalorTitle"
      :visible.sync="visibleDialogSelectApprovalor"
      width="800px"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <!-- filter -->
          <div>
            <el-radio v-model="approvalType" :label="true">固定成员</el-radio>
            <el-radio v-model="approvalType" :label="false">主管</el-radio>
          </div>
          <!-- table -->
          <section v-if="approvalType">
            <el-form
              style="margin-top: 20px; text-align: right"
              :inline="true"
              size="small"
              :model="filterModel"
            >
              <el-form-item label="">
                <el-input
                  style="width: 150px"
                  v-model="filterModel.targetId"
                  placeholder="邮箱/手机号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input
                  style="width: 150px"
                  v-model="filterModel.corpUserName"
                  placeholder="名称"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-select
                  v-model="filterModel.corpGroupId"
                  placeholder="请选择部门"
                  style="width: 150px"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    v-for="(item, i) in memberGroups"
                    :key="i"
                    :label="item.groupName"
                    :value="item.corpGroupId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-right: 0px">
                <el-button @click="handleClickSearchManager">查询</el-button>
                <el-button @click="approvalReset">重置</el-button>
              </el-form-item>
            </el-form>
            <!-- table -->
            <el-col :span="24" class="custom-table-style" style="padding: 0px">
              <el-table
                :data="tableSetManager"
                style="border: 1px solid #cbcbcb; border-bottom: 0"
                tooltip-effect="dark"
                @row-click="handleClickRow"
                highlight-current-row
                :cell-style="{ cursor: 'pointer' }"
                :header-cell-style="{
                  background: '#f9f9f9',
                  color: '#333333',
                  fontWeight: '500',
                }"
              >
                <el-table-column
                  label="邮箱/手机号"
                  prop="targetId"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="名称"
                  prop="userName"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="部门"
                  prop="groupNames"
                  show-overflow-tooltip
                ></el-table-column>
              </el-table>
            </el-col>
            <!-- pagination -->
            <el-col :span="24" style="padding: 30px 0; position: relative" class="page-flex-end">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="filterModel.itemPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="filterModel.pageSize"
                layout="sizes, prev, pager, next, total"
                :total="filterModel.pageTotal"
              />
              <el-go
                :page-size="filterModel.pageSize"
                :total="filterModel.pageTotal"
                @current-change="handleCurrentChange"
              ></el-go>
            </el-col>
          </section>
          <!-- select -->
          <section v-else>
            <div style="margin: 20px 0">
              <el-select
                v-model="selectApprovalorManagerValue"
                size="mini"
                placeholder="请选择"
              >
                <el-option
                  v-for="(v, index) in managerLevel"
                  :key="index"
                  :value="v.value"
                  :label="v.label"
                ></el-option>
              </el-select>
            </div>
          </section>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="visibleDialogSelectApprovalor = false"
          >取 消</el-button
        >
        <el-button
          size="mini"
          type="primary"
          @click="handleSelectApprovalorOk()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="选择抄送人"
      :visible.sync="visibleDialogSelectCopy"
      width="800px"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <!-- table -->
          <section>
            <el-form
              style="margin-top: 20px; text-align: right"
              :inline="true"
              size="small"
              :model="filterModel"
            >
              <el-form-item label="">
                <el-input
                  style="width: 150px"
                  v-model="filterModel.targetId"
                  placeholder="邮箱/手机号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input
                  style="width: 150px"
                  v-model="filterModel.corpUserName"
                  placeholder="名称"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-select
                  v-model="filterModel.corpGroupId"
                  placeholder="请选择部门"
                  style="width: 150px"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option
                    v-for="(item, i) in memberGroups"
                    :key="i"
                    :label="item.groupName"
                    :value="item.corpGroupId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-right: 0px">
                <el-button @click="handleClickSearchManager">查询</el-button>
                <el-button @click="approvalReset">重置</el-button>
              </el-form-item>
            </el-form>
            <!-- table -->
            <el-col :span="24" class="custom-table-style" style="padding: 0px">
              <el-table
                :data="tableSetManager"
                style="border: 1px solid #cbcbcb; border-bottom: 0"
                tooltip-effect="dark"
                @row-click="handleClickRow"
                highlight-current-row
                :cell-style="{ cursor: 'pointer' }"
                :header-cell-style="{
                  background: '#f9f9f9',
                  color: '#333333',
                  fontWeight: '500',
                }"
              >
                <el-table-column
                  label="邮箱/手机号"
                  prop="targetId"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="名称"
                  prop="userName"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  label="部门"
                  prop="groupNames"
                  show-overflow-tooltip
                ></el-table-column>
              </el-table>
            </el-col>
            <!-- pagination -->
            <el-col :span="24" style="padding: 30px 0; position: relative" class="page-flex-end">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="filterModel.itemPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="filterModel.pageSize"
                layout="sizes, prev, pager, next, total"
                :total="filterModel.pageTotal"
              />
              <el-go
                style="right: 0"
                :page-size="filterModel.pageSize"
                :total="filterModel.pageTotal"
                @current-change="handleCurrentChange"
              ></el-go>
            </el-col>
          </section>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="visibleDialogSelectCopy = false"
          >取 消</el-button
        >
        <el-button size="mini" type="primary" @click="handleSelectCopyOk()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- dialog select approval range -->
    <!-- 【1466】选择弹窗 -->
    <select-pup
      ref="choosePupREF"
      :ChooseDialogVisible.sync="ChooseDialogVisible"
      :selectUsers="approvalModel.selectUsers"
      @handleSelectUser="handleSelectUser"
    ></select-pup>
  </div>
</template>

<script>
import Flow from "../../components/flow";
import Plus from "../../components/flow/Plus";
import ElGo from "../../components/go/Go";
import selectPup from "./components/selectePup.vue"
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";

export default {
  name: "approval",
  components: { Flow, Plus, ElGo, selectPup },
  data () {
    return {
      // 【1466】
      // 查看使用范围
      viewRangeVisi: false,
      // 选择
      ChooseDialogVisible: false,
      // 【1466】 end
      // approval model include apply and sign
      approvalModelCompare: {
        aprrovalID: "",
        approvalName: "",
        approvalRange: "", // only apply approval
        approvalType: 1,
        approvalFlow: "",
        useFileAuditFlag: 1,
      },
      // approval model include apply and sign
      approvalModel: {
        aprrovalID: "",
        approvalName: "",
        approvalRange: "", // only apply approval
        selectUsers: [],
        approvalType: 1,
        approvalFlow: "",
        copyToName: "",
        useFileAuditFlag: 0,
      },
      rules: {
        approvalName: [
          { required: true, message: "请输入审批名称", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
        ],
        selectUsers: [
          { required: true, message: "请选择使用范围", trigger: ["blur", 'change'] },
        ],
        approvalFlow: [
          { required: true, message: "请设置审批流程", trigger: "blur" }
        ]
      },
      selectedApprovalRangeTags: [],

      // approval range dialog
      treeGroupIDs: [],
      findChildren: [],
      memberGroups: [],

      // approval flow
      addOrUpdateApprovalor: true, // true add , false update
      addOrUpdateCopy: true,
      managerLevel: [
        { value: 1, label: "一级主管(直接主管)" },
        { value: 2, label: "二级主管" },
        { value: 3, label: "三级主管" },
        { value: 4, label: "四级主管" },
        { value: 5, label: "五级主管" },
        { value: 6, label: "六级主管" },
        { value: 7, label: "七级主管" },
        { value: 8, label: "八级主管" },
        { value: 9, label: "九级主管" },
        { value: 10, label: "十级主管" }
      ],
      flows: [],
      copyToMembers: [],
      selectApprovalorManagerUpdate: undefined,
      selectCopyUpdate: null,
      visibleDialogSelectApprovalor: false,
      visibleDialogSelectCopy: false,
      approvalType: true,
      // filter model
      filterModel: {
        targetId: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        corpGroupId: ""
      },
      tableSetManager: [],
      selectApprovalorTableRow: {},
      selectApprovalorManagerValue: 1
    };
  },
  computed: {
    addOrUpdateApprovalorTitle () {
      if (this.addOrUpdateApprovalor) {
        return "添加审批人";
      } else {
        return "编辑审批人";
      }
    },
    hiddenArrow () {
      if (this.approvalModel.approvalType === 1) {
        return true;
      } else {
        return false;
      }
    },
    flowType () {
      return +(this.$route.query.flowType || 0);
    },
    flowId () {
      return this.$route.query.flowId ? parseInt(this.$route.query.flowId) : "";
    }
  },
  created () {
    if (this.flowId) {
      this.initApprovalInfo();
    }
  },
  methods: {
    // 【1466】 start
    /** 选择 */
    initMemberForm () {
      this.$refs.choosePupREF.initMemberForm()
    },
    /** 选择的使用范围人员 */
    handleSelectUser (val) {
      this.approvalModel.selectUsers = val
    },
    // 【1466】 end
    initApprovalInfo () {
      let params = {};
      params.flowId = this.flowId;
      ApiCorpMethods.FlowController.info(params)
        .then(res => {
          if (res.code === "0") {
            // convert form data
            if (res.data) {
              let data = res.data;
              this.approvalModel.approvalName = data.flowName;
              this.approvalModel.approvalType = data.orderFlag;
              this.approvalModel.useFileAuditFlag = data.useFileAuditFlag;
              this.approvalModel.selectUsers = data.userList
              // compare
              this.approvalModelCompare.approvalName = data.flowName;
              this.approvalModelCompare.approvalType = data.orderFlag;
              this.approvalModelCompare.useFileAuditFlag =
                data.useFileAuditFlag;

              // range
              if (data.groupList) {
                this.selectedApprovalRangeTags = data.groupList;
                let v = [];
                data.groupList.forEach(element => {
                  v.push(element.corpGroupId);
                });
                this.approvalModel.approvalRange = v.join(",");
                this.approvalModelCompare.approvalRange = v.join(",");
              }
              // flow
              if (data.partyList) {
                this.flows = data.partyList;
                // transform partyName
                data.partyList.forEach(element => {
                  if (element.partyType === 1) {
                    element.partyName = this.findLabelTool(element.targetId);
                  }
                });
                let v = [];
                this.flows.forEach(element => {
                  v.push({
                    partyType: element.partyType,
                    targetId: element.targetId
                  });
                });
                if (v.length) {
                  this.approvalModel.approvalFlow = JSON.stringify(v);
                  this.approvalModelCompare.approvalFlow = JSON.stringify(v);
                } else {
                  this.approvalModel.approvalFlow = "";
                  this.approvalModelCompare.approvalFlow = "";
                }
              }
              if (data.copyToList) {
                this.copyToMembers = data.copyToList;
                console.log(data.copyToList);
                this.approvalModel.copyToName = JSON.stringify(data.copyToList);
              }
              if (this.$refs["formApproval"]) {
                this.$refs["formApproval"].validate();
              }
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    compareIsChange () {
      let isChange = false;
      if (
        this.approvalModel.approvalName !==
        this.approvalModelCompare.approvalName
      ) {
        isChange = true;
      }
      if (
        this.approvalModel.approvalType !==
        this.approvalModelCompare.approvalType
      ) {
        isChange = true;
      }
      if (
        this.approvalModel.approvalRange !==
        this.approvalModelCompare.approvalRange
      ) {
        isChange = true;
      }
      if (
        this.approvalModel.approvalFlow !==
        this.approvalModelCompare.approvalFlow
      ) {
        isChange = true;
      }
      return isChange;
    },
    approvalCancel () {
      if (this.compareIsChange()) {
        this.$confirm("是否保存审批?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.approvalOk();
          })
          .catch(() => {
            // this.$router.push(
            //   `/console/setting?activeName=tab-approval&flowType=${
            //     this.flowType === 1 ? 1 : 0
            //   }`
            // );
            this.$router.push(
              `/console/flow?flowType=${this.flowType === 1 ? 1 : 0}`
            );
          });
      } else {
        // this.$router.push(
        //   `/console/setting?activeName=tab-approval&flowType=${
        //     this.flowType === 1 ? 1 : 0
        //   }`
        // );
        this.$router.push(
          `/console/flow?flowType=${this.flowType === 1 ? 1 : 0}`
        );
      }
    },
    approvalOk () {
      this.$refs["formApproval"].validate(valid => {
        if (valid) {
          this.approvalSave();
        }
        return false;
      });
    },

    approvalSave () {
      // reset params
      let params = {};
      params.flowId = this.flowId;
      params.flowName = this.approvalModel.approvalName;
      params.flowType = this.flowType;
      params.orderFlag = this.approvalModel.approvalType;
      if (params.flowType === 0) {
        params.groupIds = this.approvalModel.approvalRange;
      }
      params.partyArr = this.approvalModel.approvalFlow;
      params.copyToArr = this.approvalModel.copyToName;
      if (this.flowType) {
        params.useFileAuditFlag = this.approvalModel.useFileAuditFlag;
      }
      console.log(params.copyToArr);
      // if (!this.flowType) {
      //   // if (this.approvalModel.selectUsers.length === 0) return this.$message.error('请选择使用范围')
      //   console.log('this.approvalModel.selectUsers',this.approvalModel.selectUsers);
      //   let corpUserIds = this.approvalModel.selectUsers.map(item => {
      //     return item.corpUserId
      //   })
      //   params.corpUserId = corpUserIds.toString()
      // }
      if (!params.flowName) return this.$message.error("请输入审批名称");
      if (!params.partyArr) return this.$message.error("请添加审批人");
      ApiCorpMethods.FlowController.updateFlow(params)
        .then(res => {
          if (res.success) {
            // this.$router.push(`/console/setting?activeName=tab-approval&flowType=${this.flowType === 1 ? 1 : 0}`);
            this.$router.push(
              `/console/flow`
            );
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },

    // convert data for tree formate
    // 转换成tree需要的数据格式
    convertFormateTree (data) {
      data.forEach(element => {
        element.label = element.groupName;
        // element.label = '全公司';
        this.treeGroupIDs.push(element.corpGroupId);
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups);
        }
      });
      return data;
    },
    recursionChildren (childCorpGroups) {
      childCorpGroups.forEach(element => {
        element.label = element.groupName;
        this.treeGroupIDs.push(element.corpGroupId);
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups);
        }
      });
    },
    recursionFindChildren (node) {
      node.forEach(element => {
        this.findChildren.push(element.corpGroupId);
      });
      if (node.childCorpGroups) {
        this.recursionFindChildren(node.childCorpGroups);
      }
    },
    removeTag (tag) {
      this.selectedApprovalRangeTags.splice(
        this.selectedApprovalRangeTags.indexOf(tag),
        1
      );
      let IDs = [];
      this.selectedApprovalRangeTags.forEach(element => {
        IDs.push(element.corpGroupId);
      });
      this.approvalModel.approvalRange = IDs.join(",");
      if (this.$refs["formApproval"]) {
        this.$refs["formApproval"].validateField("approvalRange");
      }
    },

    handleClickFlowRemove (v) {
      if (v) {
        this.flows.splice(this.flows.indexOf(v), 1);
        this.formaterApprovalFlow();
      }
    },
    handleClickCopyRemove (v) {
      if (v) {
        this.copyToMembers.splice(this.copyToMembers.indexOf(v), 1);
        this.formaterApprovalCopy();
      }
    },
    handleClickFlowPlus () {
      this.addOrUpdateApprovalor = true;
      this.resetFilterModel();
      this.visibleDialogSelectApprovalor = true;
      this.queryTool();
    },
    handleClickCopyPlus () {
      this.addOrUpdateCopy = true;
      this.resetFilterModel();
      this.visibleDialogSelectCopy = true;
      this.queryTool();
    },
    resetFilterModel () {
      this.filterModel.targetId = "";
      this.filterModel.itemPage = 1;
      this.filterModel.pageSize = 10;
      this.filterModel.pageTotal = 0;
      this.tableSetManager = [];
    },
    handleClickFlowUpdate (v) {
      this.addOrUpdateApprovalor = false;
      this.resetFilterModel();
      this.visibleDialogSelectApprovalor = true;
      this.queryTool();
      this.selectApprovalorManagerUpdate = v;
    },
    handleClickCopyUpdate (v) {
      this.addOrUpdateCopy = false;
      this.resetFilterModel();
      this.visibleDialogSelectCopy = true;
      this.queryTool();
      this.selectCopyUpdate = v;
    },

    handleSelectApprovalorOk () {
      // 5/16 老刘说这里是报错，记录在【产品@开发协调沟通】群里聊天记录九点
      // 后来发现这个判断一直为true，注释
      // if(this.selectApprovalorTableRow.identityAuth !==1) return this.$message.warning('未实名认证的成员不能参与审批流程')
      let v = {};
      // fixed member
      if (this.approvalType) {
        v.partyType = 0;
        v.targetId = this.selectApprovalorTableRow.corpUserId;
        v.partyName = this.selectApprovalorTableRow.userName;
      } else {
        // manager level
        v.partyType = 1;
        v.targetId = this.selectApprovalorManagerValue;
        v.partyName = this.findLabelTool(this.selectApprovalorManagerValue);
      }
      if (v.partyName || v.targetId) {
        // is exist
        let exist = false;
        for (let index = 0; index < this.flows.length; index++) {
          const element = this.flows[index];
          if (
            element.partyType === v.partyType &&
            element.targetId === v.targetId
          ) {
            exist = true;
            break;
          }
        }
        if (exist) {
          this.$message.error("审批人不能重复");
          return;
        }
        if (this.selectApprovalorManagerUpdate) {
          // update
          this.flows.splice(
            this.flows.indexOf(this.selectApprovalorManagerUpdate),
            1,
            v
          );
          this.formaterApprovalFlow();
        } else {
          // new add
          this.flows.push(v);
          this.formaterApprovalFlow();
        }
        this.visibleDialogSelectApprovalor = false;
        this.selectApprovalorManagerUpdate = undefined;
      } else {
        this.$message.error("请选择审批人");
      }
    },
    handleSelectCopyOk () {
      let v = {};
      // fixed member
      v.partyType = 0;
      v.targetId = this.selectApprovalorTableRow.corpUserId;
      v.partyName = this.selectApprovalorTableRow.userName;

      if (v.partyName || v.targetId) {
        let exist = false;
        for (let index = 0; index < this.copyToMembers.length; index++) {
          const element = this.copyToMembers[index];
          if (
            element.partyType === v.partyType &&
            element.targetId === v.targetId
          ) {
            exist = true;
            break;
          }
        }
        if (exist) {
          this.$message.error("抄送人不能重复");
          return;
        }
        if (this.selectCopyUpdate) {
          // update
          this.copyToMembers.splice(
            this.copyToMembers.indexOf(this.selectCopyUpdate),
            1,
            v
          );
          this.formaterApprovalCopy();
        } else {
          // new add
          this.copyToMembers.push(v);
          this.formaterApprovalCopy();
        }
        this.visibleDialogSelectCopy = false;
        this.selectCopyUpdate = null;
      } else {
        this.$message.error("请选择抄送人");
      }
    },

    findLabelTool (value) {
      let label = "";
      this.managerLevel.forEach(element => {
        if (value === element.value) {
          label = element.label;
        }
      });
      return label;
    },

    formaterApprovalFlow () {
      let v = [];
      this.flows.forEach(element => {
        v.push({
          partyType: element.partyType,
          targetId: element.targetId
        });
      });
      if (v.length) {
        this.approvalModel.approvalFlow = JSON.stringify(v);
      } else {
        this.approvalModel.approvalFlow = "";
      }
      if (this.$refs["formApproval"]) {
        this.$refs["formApproval"].validateField("approvalFlow");
      }
    },
    formaterApprovalCopy () {
      let v = [];
      this.copyToMembers.forEach(element => {
        v.push({
          partyType: element.partyType,
          targetId: element.targetId
        });
      });
      if (v.length) {
        this.approvalModel.copyToName = JSON.stringify(v);
      } else {
        this.approvalModel.copyToName = "";
      }
    },

    // pagination event
    // 分页事件
    handleSizeChange (val) {
      this.filterModel.itemPage = 1;
      this.filterModel.pageSize = val;
      this.queryTool();
    },
    handleCurrentChange (val) {
      this.filterModel.itemPage = val;
      this.queryTool();
    },
    // table related events
    // query member table data
    queryTool () {
      this.selectApprovalorTableRow = {};
      ApiCorpMethods.OrganizationController.listCorpUsers(this.filterModel)
        .then(res => {
          if (res.code === "0") {
            this.tableSetManager = res.data;
            this.filterModel.pageTotal = res.total;
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    // 重置
    approvalReset () {
      this.filterModel = {
        targetId: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        corpGroupId: ""
      }
      this.handleClickSearchManager()
    },
    handleClickSearchManager () {
      this.queryTool();
    },
    handleClickRow (row) {
      if(row.identityAuth !==1) return this.$message.warning('未实名认证的成员不能参与审批流程')
      this.selectApprovalorTableRow = row;
    }
  },
  beforeDestroy () { }
};
</script>

<style scoped>
.console-wrap >>> .el-container {
  margin-bottom: 140px !important;
}
.approval {
  padding: 20px;
  position: relative;
  background: #ffffff;
}

.title {
  margin: 30px 0;
}

.title h1 {
  font-size: 16px;
  font-family: "微软雅黑";
}

.custom-inline {
  margin-bottom: 10px;
}

.custom-inline >>> .el-tag {
  margin-top: 10px;
  margin-right: 10px;
}

.footer {
  border-top: 1px solid #cccccc;
  padding: 15px;
}

.custom-a {
  color: #5597ec;
  text-decoration: underline;
}

.custom-a:hover {
  color: red;
}

.custom-table-style >>> .el-table__body tr.current-row > td {
  /*background-color: #fda2a2;*/
  color: #ec1c1c;
}

.content >>> .el-form-item {
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// pages/console/Approval.vue